var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-design",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.6,67V12.1a3.9,3.9,0,0,0-3.9-4H29.1A15.7,15.7,0,0,0,13.4,23.8V76.2A15.7,15.7,0,0,0,29.1,91.9H82.7a3.9,3.9,0,0,0,3.9-4V85.3a4.1,4.1,0,0,0-1.4-3,36.3,36.3,0,0,1,0-12.3,4.1,4.1,0,0,0,1.4-3ZM34.3,30.1a.9.9,0,0,1,1-1H69.9a.9.9,0,0,1,1,1v3.2a.9.9,0,0,1-1,1H35.3a.9.9,0,0,1-1-1Zm0,10.4a1,1,0,0,1,1-1H69.9a1,1,0,0,1,1,1v3.3a1,1,0,0,1-1,1H35.3a1,1,0,0,1-1-1ZM75.7,81.4H29.1a5.2,5.2,0,0,1-5.3-5.2,5.3,5.3,0,0,1,5.3-5.3H75.7A61.4,61.4,0,0,0,75.7,81.4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.db93d346.svg";
export { ForwardRef as ReactComponent };